export default __webpack_public_path__ + "static/media/bt.207c8534.png";